import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { MAX_MEDIUM_DEALS_PER_ROW } from '../../../config/setup/setup';
import { cutArray } from '../../../helpers/deals';
import { getAllBlocks } from '../../../helpers/dealsBlocks';

const BlockWithOneFeaturedDeal = ({ deals, isNewFilterApplied, position }) => {
  const cutDealsArray = cutArray(deals, MAX_MEDIUM_DEALS_PER_ROW);
  const filtersURL = useSelector((state) => state.filters.url);

  return (
    <>{getAllBlocks(cutDealsArray, position, filtersURL, isNewFilterApplied)}</>
  );
};

BlockWithOneFeaturedDeal.propTypes = {
  deals: PropTypes.arrayOf(PropTypes.object),
  position: PropTypes.number,
};

BlockWithOneFeaturedDeal.defaultProps = {
  deals: [],
  position: 0,
};

export default BlockWithOneFeaturedDeal;
